import { Component, OnInit, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SobreBlancoService } from '../../../services/sobre-blanco.service';
import { ObrasService } from '../../../services/obras.service';

declare var $: any;

/**
 * Modal para capturar un Nuevo Movimiento a Carpeta Blanca desde la pantalla
 * de Movimientos de Obra. Reusa el mismo flujo y servicio que el componente
 * /sobre-blanco. Se monta cuando el modo sobre esta activo (users.key === 1).
 */
@Component({
  selector: 'app-modal-nuevo-mov-carpeta-blanca',
  templateUrl: './modal-nuevo-mov-carpeta-blanca.component.html'
})
export class ModalNuevoMovCarpetaBlancaComponent implements OnInit {

  @Output() onGuardado: EventEmitter<any> = new EventEmitter();
  @ViewChild('content') private content: TemplateRef<any>;

  private modal: any = null;

  public tiposMovimiento = [
    { id: 1, nombre: 'Ingreso a reembolso' },
    { id: 2, nombre: 'Traspaso entre cuentas' },
    { id: 5, nombre: 'Ingreso a cuenta' }
  ];

  // Mismos filtros que usa el componente /sobre-blanco
  private readonly OBRAS_TRASPASO_PERMITIDAS = [11, 17, 21];
  private readonly OBRAS_INGRESO_CUENTA_PERMITIDAS = [1, 11, 13, 17, 21];

  public obras: any[] = [];
  public obrasTraspaso: any[] = [];
  public obrasIngresoCuenta: any[] = [];

  public movimiento: any = {};
  public guardando: boolean = false;

  constructor(
    private modalService: NgbModal,
    private sobreBlancoService: SobreBlancoService,
    private obrasService: ObrasService
  ) {}

  ngOnInit() {
    this.cargarObras();
  }

  cargarObras() {
    this.obrasService.getObratoSelect().subscribe(response => {
      this.obras = response.json().content || [];
      this.obrasTraspaso = this.obras.filter(o => this.OBRAS_TRASPASO_PERMITIDAS.indexOf(parseInt(o.idObras)) !== -1);
      this.obrasIngresoCuenta = this.obras.filter(o => this.OBRAS_INGRESO_CUENTA_PERMITIDAS.indexOf(parseInt(o.idObras)) !== -1);
    });
  }

  open() {
    this.movimiento = {};
    if (!this.obras || this.obras.length === 0) {
      this.cargarObras();
    }
    this.modal = this.modalService.open(this.content, { size: 'lg' as any, backdrop: 'static' });
  }

  closeModal() {
    if (this.modal) {
      this.modal.close();
      this.modal = null;
    }
    this.movimiento = {};
  }

  limpiar() {
    this.movimiento = {};
  }

  guardar() {
    if (!this.movimiento.tipoMovimiento) {
      this.notify('Advertencia', 'Falta seleccionar el Tipo de Movimiento.', 'warning');
      return;
    }
    if (!this.movimiento.importe) {
      this.notify('Advertencia', 'Falta capturar el Importe.', 'warning');
      return;
    }
    if (!this.movimiento.descripcion) {
      this.notify('Advertencia', 'Falta capturar la Descripción.', 'warning');
      return;
    }
    if (this.movimiento.tipoMovimiento == 1 && !this.movimiento.porcentajeComision) {
      this.notify('Advertencia', 'Debes capturar el porcentaje de comisión.', 'warning');
      return;
    }
    if (this.movimiento.tipoMovimiento == 2 && !this.movimiento.idObra) {
      this.notify('Advertencia', 'Debes seleccionar la obra para el traspaso.', 'warning');
      return;
    }
    if (this.movimiento.tipoMovimiento == 5 && !this.movimiento.idObra) {
      this.notify('Advertencia', 'Debes seleccionar la obra para el ingreso a cuenta.', 'warning');
      return;
    }

    this.guardando = true;
    this.sobreBlancoService.guardarMovimiento(this.movimiento).subscribe(response => {
      const body = response.json();
      this.guardando = false;
      this.notify('Éxito', body.mensaje || 'Movimiento guardado.', 'success');
      this.onGuardado.emit(body);
      this.closeModal();
    }, error => {
      this.guardando = false;
      let msg = 'No se pudo guardar el registro.';
      try { msg = error.json().mensaje || msg; } catch (e) {}
      this.notify('Error', msg, 'error');
    });
  }

  private notify(title: string, msg: string, type: string) {
    if ($ && $.NotificationApp) {
      $.NotificationApp.send(title, msg, 'top-right', 'rgba(0,0,0,0.2)', type);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/movimientos-obra/modal-nuevo-mov-carpeta-blanca/modal-nuevo-mov-carpeta-blanca.component.ts